
<app-dialog [header]="getHeaderText()"
            [subHeader]="getSubHeaderText()"
            [hideHeaderUnderline]="true"
            [show]="true"
            [maxWidth]="675"
>
  <div class="receive-attachments-dialog-container styled-main-scroll"
  >
    <app-file-uploader [hidden]="parsedFile"
                       [autoUpload]="true"
                       dropFilesText="Drag and drop the file or"
                       link="browse"
                       accept="text/csv, text/plain, .xlsx, .xls"
                       [heightInRem]="12.5"
                       [error]="fileUploaderError"
                       (afterFileUploaded)="addAttachmentFile($event)"
                       (afterFileSelected)="afterFileSelected($event)"
    ></app-file-uploader>
      <div class="columns flex flex-col" *ngIf="headers?.length && parsedFile">
        <div class="select-cols" [formGroup]="form">
          <app-dropdown label="NDC"
                  (chosenOption)="ndcHeaderSelected($event)"
                  [options]="headers"
                  [isLoading]="!headers.length"
                  [placeholder]="'Select'"
                  formControlName="ndcHeaderValidity"
          ></app-dropdown>
          <app-dropdown label="Quantity"
                  (chosenOption)="countHeaderSelected($event)"
                  [options]="headers"
                  [isLoading]="!headers.length"
                  [placeholder]="'Select'"
                  formControlName="qtyHeaderValidity"
          ></app-dropdown>
        </div>
        <div class="mt-5 text-xs self-start">If you don't find NDC and Qty in the list, 
          <span class="underline underline-offset-2 cursor-pointer" (click)="uploadAnotherFile()">upload another file</span>
        </div>
      </div>
  </div>

  <div class="dialog-controls-default">
    <app-button customClasses="px-4"
                text="Cancel"
                [minWidth]="0"
                subStyle="transparent"
                class="cancel-btn"
                (clicked)="close()"
    >
    </app-button>

    <app-button customClasses="px-4"
                [text]="'Load Inventory'"
                class="save-btn"
                [disabled]="(loading$ | async) || form.invalid"
                [loading]="loading$ | async"
                (clicked)="loadInventory()"
    >
    </app-button>
  </div>
</app-dialog>
